import React from 'react';
import { Chip } from '../../../components/technician/ui/Chip';
import { STATE_STATUS_SPECS } from '../catalog/status';
import type { StateStatus } from '../catalog/status';

export interface StatusChipProps {
  status: StateStatus;
}

/** How one key state stands against the device, in one badge. */
export const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const spec = STATE_STATUS_SPECS[status];
  return <Chip label={spec.label} tone={spec.tone} />;
};

export default StatusChip;
